import { Copy } from '../copy/Copy';
import { Support } from '../icons/Support/Support';
import { Mic } from '../icons/Mic/Mic';
import { Theatre } from '../icons/Theatre/Theatre';

export const ACADEMY = [
  {
    icon: Mic,
    heading: Copy.generate('Academy.features.list.1.title'),
    content: Copy.generate('Academy.features.list.1.content'),
  },
  {
    icon: Theatre,
    heading: Copy.generate('Academy.features.list.2.title'),
    content: Copy.generate('Academy.features.list.2.content'),
  },
  {
    icon: Support,
    heading: Copy.generate('Academy.features.list.3.title'),
    content: Copy.generate('Academy.features.list.3.content'),
  },
];
